import { SxProps, Theme } from '@mui/material';

export const ViewWrapperPaperStyles: SxProps<Theme> = {
  borderTopLeftRadius: '0px !important',
  borderTopRightRadius: '0px !important',
  maxWidth: '100% !important',
  p: '0 !important',
};
